import { PhotoshopController } from "../photoshopController.js";
import { ColorsWidget } from "./colorWidget.js";
import { LayersWidget } from "./layersWidget.js";
import { FiltersWidget } from "./filtersWidget.js";
import { PhotoshopWidget } from "./photoshopWidget.js";
export class DatasPanelWidget {
    parentElement: HTMLElement;
    photoshopController: PhotoshopController;
    photoshopWidget: PhotoshopWidget;
    colorsWidget: ColorsWidget;
    layersWidget: LayersWidget;
    filtersWidget: FiltersWidget;

    PSLuminosityContrast_settingOnClick: any;
    PSLevels_settingOnClick: any;
    PSHueSaturation_settingOnClick: any;
    PSColorBalance_settingOnClick: any;

    constructor(parentElement: HTMLElement, controller: PhotoshopController, photoshopWidget: PhotoshopWidget) {
        this.parentElement = parentElement;
        this.photoshopController = controller;
        this.photoshopWidget = photoshopWidget;

        this.colorsWidget = new ColorsWidget(this.parentElement, this.photoshopController);
        this.layersWidget = new LayersWidget(this.parentElement, this.photoshopController);
        this.filtersWidget = new FiltersWidget(this.parentElement, this.photoshopController, this, photoshopWidget);

        //colorsWidget events
        this.colorsWidget.initializeColorPicker();
        this.colorsWidget.updateStyle();

        //filtersWidget events
        this.PSLuminosityContrast_settingOnClick = this.filtersWidget.luminosityContrast_settingOnClick.bind(this);
        this.PSLevels_settingOnClick = this.filtersWidget.levels_settingOnClick.bind(this);
        this.PSHueSaturation_settingOnClick = this.filtersWidget.hueSaturation_settingOnClick.bind(this);
        this.PSColorBalance_settingOnClick = this.filtersWidget.colorBalance_settingOnClick.bind(this);
    }

    static html() {
        return `
        <div style="float: left; width: 380px;">
            ` + ColorsWidget.html() + `
            ` + FiltersWidget.html() + `
            ` + LayersWidget.html() + `
        </div>
        `;
    }

    resize(event) {
        this.layersWidget.resize();
    }

    destroy() {
        this.colorsWidget.destroy();
    }
}